import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { AlertType, Alert } from '@app/core/domain';
import { AlertStateBase } from './alert-state.interface';

export type AlertLevel = 'SUCCESS' | 'INFO' | 'WARNING' | 'DANGER' | 'PRIMARY' | 'SECONDARY' | 'LIGHT' | 'DARK';

export interface AlertFacadeInterface {
  getAlerts(): Observable<Array<Alert>>;
  addAlert(type: AlertLevel, message: string): void;
  addAlertByKey(type: AlertLevel, messageKey: string): void;
  removeAlert(id: number): void;
}

@Injectable()
export class AlertFacade implements AlertFacadeInterface {

  private counter = 0;

  constructor(
    private state: AlertStateBase,
    private translate: TranslateService,
  ) { }

  getAlerts(): Observable<Array<Alert>> {
    return this.state.getAlerts();
  }

  addAlert(
    type: AlertLevel,
    message: string,
    duration: number = 3
  ): void {
    this.counter++;
    const id = this.counter;
    this.state.setAlert({ id, type: AlertType[type], message });
    setTimeout(() => this.removeAlert(id), duration * 1000);
  }

  addAlertByKey(
    type: AlertLevel,
    messageKey: string,
    duration: number = 3
  ): void {
    const message = this.translate.instant(messageKey);
    this.addAlert(type, message, duration);
  }

  removeAlert(id: number): void {
    this.state.removeAlert(id);
  }
}
